import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdatePruebaConfesionalRequest } from '@models/pruebas/pruebaConfesional/updatePruebaConfesionalRequest.model';
import { CreatePruebaConfesionalRequest } from '@models/pruebas/pruebaConfesional/createPruebaConfesionalRequest.model';
import { PruebaConfesionalDto } from '@models/pruebas/pruebaConfesional/pruebaConfesionalDto.model';
import { PruebaConfesionalFilter } from '@models/pruebas/pruebaConfesional/pruebaConfesionalFilter.model';

@Injectable({
  providedIn: 'root'
})
export class PruebaConfesionalService {

  constructor(private http:HttpClient) {
  }

  create(createPruebaConfesionalRequest:CreatePruebaConfesionalRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/PruebaConfesional/Create",createPruebaConfesionalRequest);
  }

  update(updatePruebaConfesionalRequest:UpdatePruebaConfesionalRequest):Observable<any>
  {
    return  this.http.put<any>("/api/PruebaConfesional/Update",updatePruebaConfesionalRequest);
  }

  getAll():Observable<PruebaConfesionalDto[]> {
    return   this.http.get<PruebaConfesionalDto[]>("/api/PruebaConfesional/GetAll");
  }

  getAllByIdExpediente(idExpediente:number):Observable<PruebaConfesionalDto[]> {
    return   this.http.get<PruebaConfesionalDto[]>("/api/PruebaConfesional/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getAllByFilter(pruebaConfesionalFilter: PruebaConfesionalFilter):Observable<PruebaConfesionalDto[]> {
    return   this.http.post<PruebaConfesionalDto[]>("/api/PruebaConfesional/GetAllByFilter",pruebaConfesionalFilter);
  }


  getById(id:number):Observable<PruebaConfesionalDto>{
    return  this.http.get<PruebaConfesionalDto>("/api/PruebaConfesional/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/PruebaConfesional/Delete?id=" + id);
    else
      return of(null)
  }

  // Utility methods
  getMedioRegistroSugeridos(): string[] {
    return [
      'Audio',
      'Video',
      'Escrito',
      'Audio y Video',
      'Declaración Jurada',
      'Testimonio Oral',
      'Acta Notarial',
      'Grabación Digital'
    ];
  }

}
